import type React from "react";

import { LicenceAgreementForm } from "./licensing";
import { useLicenceAgreement } from "./hooks";
import { useEffect, useRef } from "react";
import { useDebouncedCallback } from "@react-hookz/web";
import { useSetAtom } from "jotai";
import { gridLoadingAtom } from "../../stateAtoms";
import { useUserAmendExchangeUsage } from "../../data/user";
import { useCurrentUsername, useUserId } from "../../context/auth/hooks";

export function LicenceAgreement({ children }: { children: React.ReactNode }) {
  const { licenceAgreement, sourceId, isInitialLoading } = useLicenceAgreement();
  const setGridLoading = useSetAtom(gridLoadingAtom);
  const amend = useUserAmendExchangeUsage();
  const username = useCurrentUsername();
  const userId = useUserId();
  const hasResolvedInitialLoad = useRef(false);

  useEffect(() => {
    if (!isInitialLoading) {
      hasResolvedInitialLoad.current = true;
    }
  }, [isInitialLoading]);

  useEffect(() => {
    if (isInitialLoading && !hasResolvedInitialLoad.current) return;
    setGridLoading(false);
  }, [isInitialLoading, setGridLoading]);

  const signArtisAgreement = useDebouncedCallback(
    (newExchanges) => {
      amend.mutate({ exchangeUsages: newExchanges });
    },
    [amend.mutate],
    5_000,
  );

  useEffect(() => {
    if (licenceAgreement === "ARTIS" && sourceId && userId) {
      const newExchanges = [
        {
          folio_user: userId,
          source: sourceId,
          event: "start",
        },
      ];
      signArtisAgreement(newExchanges);
    }
  }, [licenceAgreement, sourceId, userId, signArtisAgreement]);

  if (isInitialLoading && !hasResolvedInitialLoad.current) return null;
  if (!licenceAgreement || licenceAgreement === "ARTIS") return children;
  return <LicenceAgreementForm agreementType={licenceAgreement} username={username} sourceId={sourceId} />;
}
